import React from 'react'

interface RecurringIconProps extends React.SVGProps<SVGSVGElement> {
  width?: string | number
  height?: string | number
  fill?: string
}

export const RecurringIcon: React.FC<RecurringIconProps> = ({
  width = '20px',
  height = '20px',
  style,
  fill = '#A1A1A1',
  ...props
}) => {
  return (
    <svg
      viewBox="0 0 32 33"
      width={width}
      height={height}
      fill="none"
      {...props}
    >
      <path
        d="M25 14.62H18.22L20.96 11.8C18.23 9.1 13.81 9 11.08 11.7C8.35 14.41 8.35 18.78 11.08 21.49C13.81 24.2 18.23 24.2 20.96 21.49C22.32 20.15 23 18.58 23 16.6H25C25 18.58 24.12 21.15 22.36 22.89C18.85 26.37 13.15 26.37 9.64 22.89C6.14 19.42 6.11 13.78 9.62 10.31C13.13 6.84 18.76 6.84 22.27 10.31L25 7.5V14.62Z"
        fill={fill}
      />
    </svg>
  )
}
